module.exports = __webpack_public_path__ + "media/flags/to-be894d62.svg";